import { Chip, Link } from '@raisin/components-lib';
import React, { useEffect, useRef, useState } from 'react';
import * as S from './styles';

export const FinancialInstitutions = ({
  financialInstitutions,
}: {
  financialInstitutions: string[];
}) => {
  const [showAll, setShowAll] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [containerWidth, setContainerWidth] = useState(200);
  const maxVisible = 3;

  const hiddenCount = financialInstitutions.length - maxVisible;
  const visibleItems = showAll ? financialInstitutions : financialInstitutions.slice(0, maxVisible);
  useEffect(() => {
    if (containerRef.current) {
      const childWidths = Array.from(containerRef.current.children).map(
        (child) => child.getBoundingClientRect().width + 8,
      );
      const visibleCount = showAll ? financialInstitutions.length : 3;
      const totalWidth = childWidths.slice(0, visibleCount).reduce((a, b) => a + b, 0);
      setContainerWidth(totalWidth);
    }
  }, [showAll, financialInstitutions.length]);

  return (
    <S.Wrapper>
      <S.ChipContainer width={containerWidth} ref={containerRef}>
        {visibleItems.map((item, index) => (
          <Chip
            style={{ marginRight: 8, marginBottom: 8 }}
            color="secondary"
            label={item}
            size="small"
            key={index}
          />
        ))}
      </S.ChipContainer>
      {financialInstitutions.length > maxVisible && (
        <S.Link>
          <Link style={{ fontWeight: 'bold' }} onClick={() => setShowAll(!showAll)}>
            {showAll ? 'Show less' : `+${hiddenCount} more`}
          </Link>
        </S.Link>
      )}
    </S.Wrapper>
  );
};
